// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3QGPN","overflowing":"ReadFullNote_overflowing__1wctg"};